/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import apiService from '../../axios/apiService';
import PropTypes from 'prop-types';
import RadiologistUserForm from './RadiologistUserForm';
import { notification } from 'antd';
import { AxiosError } from 'axios';
import { BAD_REQUEST_STATUS_CODE } from '../../axios/constants';

const EditRadiologist = forwardRef(function EditRadiologist(
  { formValues, onSuccess, onError },
  ref
) {
  const formRef = useRef(null);
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);

  useImperativeHandle(
    ref,
    () => ({
      reset: formRef?.current?.reset, // eslint-disable-line no-unused-labels
    }),
    []
  );

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const response = await apiService.updateStaff(data);
      api.success({ message: 'Success', description: response?.message });
      setLoading(false);
      onSuccess?.(response);
    } catch (error) {
      setLoading(false);
      onError?.(error);
      if (
        error instanceof AxiosError &&
        error?.response?.status === BAD_REQUEST_STATUS_CODE &&
        !error?.response?.data?.formErrorMessage
      )
        return;
      api.error({
        message: 'Error',
        description: error?.message,
        showProgress: false,
      });
    }
  };

  return (
    <>
    {contextHolder}
    <RadiologistUserForm
      formValues={formValues}
      onSubmit={onSubmit}
      loading={loading}
      ref={formRef}
      isEdit
    />
    </>
  );
});

EditRadiologist.propTypes = {
  formValues: PropTypes.object,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

export default EditRadiologist;
